// FeatureCard.jsx
import React from "react";
import "../../styles/FeatureCardStart.css";

/**
 * FeatureCard – horizontale Card wie im Screenshot
 *
 * Props:
 * - title: string
 * - description: string | React.ReactNode
 * - icon: React.ReactNode (z.B. <Search /> von lucide-react)
 * - className?: string
 * - onClick?: () => void
 */
const FeatureCard = ({
    title,
    description,
    icon,
    className = "",
    onClick,
    style,
    ...rest
}) => {
    // Wir prüfen, ob die Box vertikal sein soll
    const isVertical = className.includes("vertical");

    return (
        <div
            className={`feature-card-wrapper ${className}`}
            onClick={onClick}
            style={{
                ...style,
                display: "flex",
                flexDirection: isVertical ? "column" : "row",
                alignItems: "center",
                cursor: onClick ? "pointer" : "default"
            }}
            {...rest}
        >
            {/* Icon-Block */}
            <div className="icon-container">
                {icon}
            </div>

            {/* Textbereich */}
            <div className="text-container">
                <h3 className="title">{title}</h3>
                {description && <p className="description">{description}</p>}
            </div>
        </div>
    );
};

export default FeatureCard;

